var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "json-editor"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("JSON Editor")]), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: _vm.openModal,
      callback: function callback($$v) {
        _vm.openModal = $$v;
      },
      expression: "openModal"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column"
  }, [_c('v-toolbar', {
    staticClass: "flex-grow-0",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('v-toolbar-title', [_vm._v("JSON Editor (ADMIN ONLY)")]), _c('v-spacer'), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1), _c('v-card-text', {
    staticClass: "flex-grow-1 editor-ctn pa-5"
  }, [_c('vue-json-editor', {
    staticClass: "fullscreen",
    attrs: {
      "mode": "code",
      "expandedOnStart": true
    },
    on: {
      "change": _vm.onJsonChange
    },
    model: {
      value: _vm.json,
      callback: function callback($$v) {
        _vm.json = $$v;
      },
      expression: "json"
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }